<!-- <button
  mat-button
  vueTableMenuOpen
  vueOverlayOpen
  class="menu-trigger"
 
  
> -->
  <mat-icon [matMenuTriggerFor]="allPoolsMenu">more_horiz</mat-icon>
<!-- </button> -->
<mat-menu #allPoolsMenu="matMenu" class="all-pools-menu">
  
  <button
    mat-menu-item  (click)="downloadFile(elements)"
>Download
  </button>
  
   <button mat-menu-item  (click)="submitUndoData($event,elements)" >
   Undo
  </button>
</mat-menu>
<!-- <vue-toast icon="success">
  <span toast-body>{{ toastMessage }}</span>
</vue-toast> -->

